import { Card } from "@shared/ui/card";
import { Progress } from "@shared/ui/progress";
import { CheckCircle, AlertCircle, Building2 } from "lucide-react";
import { Button } from "@shared/ui/button";
import { useNavigate } from "react-router-dom";
import { Task } from "../../types";

interface OrganizationSetupCardProps {
  progress: number;
  tasks: Task[];
}

export function OrganizationSetupCard({
  progress,
  tasks,
}: OrganizationSetupCardProps) {
  const navigate = useNavigate();

  return (
    <Card className="p-4 flex flex-col h-full">
      <div className="space-y-4 flex-1">
        {/* Header */}
        <div className="flex items-center gap-2">
          <Building2 className="h-5 w-5" />
          <h3 className="font-medium">Organization Setup</h3>
        </div>

        {/* Progress */}
        <div>
          <div className="flex justify-between text-sm mb-2">
            <span className="text-muted-foreground">Setup progress</span>
            <span>{progress}%</span>
          </div>
          <Progress value={progress} className="h-2" />
        </div>

        {/* Tasks List */}
        <div className="space-y-1.5">
          {tasks.map((task, index) => (
            <div key={index} className="flex items-center gap-2 text-sm">
              {task.isSetupCompleted ? (
                <CheckCircle className="h-4 w-4 text-green-500 shrink-0" />
              ) : (
                <AlertCircle className="h-4 w-4 text-amber-500 shrink-0" />
              )}
              <span>{task.fieldName}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Button */}
      <Button
        className="w-full mt-auto"
        onClick={() => navigate("/onboarding/org-setup/dashoard")}
      >
        Complete Setup
      </Button>
    </Card>
  );
}
